import React from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { FamilyProvider } from './contexts/FamilyContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { KioskProvider } from './contexts/KioskContext'
import { CelebrationProvider } from './contexts/CelebrationContext'

// Pages
import LandingPage from './pages/LandingPage'
import LoginPage from './pages/auth/LoginPage'
import SignupPage from './pages/auth/SignupPage'
import OnboardingWizard from './pages/auth/OnboardingWizard'
import Dashboard from './pages/Dashboard'
import TasksPage from './pages/TasksPage'
import RewardsPage from './pages/RewardsPage'
import RewardTrackingPage from './pages/RewardTrackingPage'
import CalendarPage from './pages/CalendarPage'
import SettingsPage from './pages/SettingsPage'
import ChildView from './pages/ChildView'
import KioskPage from './pages/KioskPage'
import DebugPage from './pages/DebugPage'
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage'
import TermsOfServicePage from './pages/legal/TermsOfServicePage'

// Components
import EmailConfirmationHandler from './components/auth/EmailConfirmationHandler'
import ProtectedRoute from './components/auth/ProtectedRoute'
import AuthRoute from './components/auth/AuthRoute'

import './App.css'

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <FamilyProvider>
          <KioskProvider>
            <CelebrationProvider>
              <Router>
                <div className="App">
                  <Routes>
                    {/* Public Routes */}
                    <Route path="/" element={<LandingPage />} />
                    <Route path="/privacy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms" element={<TermsOfServicePage />} />
                    <Route path="/auth/confirm" element={<EmailConfirmationHandler />} />
                    
                    {/* Auth Routes (redirect if already logged in) */}
                    <Route 
                      path="/login" 
                      element={
                        <AuthRoute>
                          <LoginPage />
                        </AuthRoute>
                      } 
                    />
                    <Route 
                      path="/signup" 
                      element={
                        <AuthRoute>
                          <SignupPage />
                        </AuthRoute>
                      } 
                    />
                    
                    {/* Protected Routes */}
                    <Route 
                      path="/onboarding" 
                      element={
                        <ProtectedRoute requiresOnboarding={true}>
                          <OnboardingWizard />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/dashboard" 
                      element={
                        <ProtectedRoute>
                          <Dashboard />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/tasks" 
                      element={
                        <ProtectedRoute>
                          <TasksPage />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/rewards" 
                      element={
                        <ProtectedRoute>
                          <RewardsPage />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/reward-tracking" 
                      element={
                        <ProtectedRoute>
                          <RewardTrackingPage />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/calendar" 
                      element={
                        <ProtectedRoute>
                          <CalendarPage />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/settings" 
                      element={
                        <ProtectedRoute>
                          <SettingsPage />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/child/:childId" 
                      element={
                        <ProtectedRoute>
                          <ChildView />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/kiosk" 
                      element={
                        <ProtectedRoute>
                          <KioskPage />
                        </ProtectedRoute>
                      } 
                    />
                    <Route 
                      path="/debug" 
                      element={
                        <ProtectedRoute>
                          <DebugPage />
                        </ProtectedRoute>
                      } 
                    />
                    
                    {/* Redirect unknown routes to dashboard for authenticated users, login for unauthenticated */}
                    <Route 
                      path="*" 
                      element={
                        <ProtectedRoute>
                          <Navigate to="/dashboard" replace />
                        </ProtectedRoute>
                      } 
                    />
                  </Routes>
                </div>
              </Router>
            </CelebrationProvider>
          </KioskProvider>
        </FamilyProvider>
      </AuthProvider>
    </ThemeProvider>
  )
}

export default App